<template>
  <draggable
    :list="currentField.data"
    :group="currentField.key"
    :sort="true"
    @change="changeFields"
    :class="{
      'justify-center ': mainExpression == 'Preview',
      'pb-4': mainExpression !== 'Preview',
    }"
    class="form-title row ma-0"
    ghost-class="sortable__ghost"
  >
    <template v-for="(field, index) in currentField.data">
      <span
        v-if="!field.cols"
        :key="`${field.fieldType}-${field.id}`"
        class="form__group__element d-inline-block"
        :class="{
          'is--active': field === activeFieldExpression,
          'form__group__element--hover': mainExpression == 'Edit',
        }"
      >
        <div
          class="pa-0 d-flex"
          @click.stop="editElementProperties(field)"
          :id="'form-' + index"
        >
          <component :is="field.fieldType" :currentField="field" />
        </div>

        <!-- Actions list -->
        <div class="form__actiongroup">
          <div class="form__actionlist">
            <v-icon small @click.stop="deleteElement(index, currentField.data)"
              >fas fa-times-circle</v-icon
            >
          </div>
        </div>
      </span>
      <v-col
        :cols="field.cols"
        v-else
        class="form__group__element pa-0"
        :class="{
          'is--active': field === activeFieldExpression,
          'form__group__element--hover': mainExpression == 'Edit',
        }"
        :key="`${field.fieldType}-${field.id}`"
      >
        <div
          class="pa-0 d-flex"
          @click.stop="editElementProperties(field)"
          :id="'form-' + index"
        >
          <component :is="field.fieldType" :currentField="field" />
        </div>

        <!-- Actions list -->
        <div class="form__actiongroup">
          <div class="form__actionlist">
            <v-icon small @click.stop="deleteElement(index, currentField.data)"
              >fas fa-times-circle</v-icon
            >
          </div>
        </div>
      </v-col>
    </template>
  </draggable>
</template>

<script>
import { FormBuilder } from "@/components/form_elements_expression/formbuilderElements.js";
const { v4: uuidv4 } = require("uuid");
import vm from "@/main";

export default {
  name: "FormTitle",
  components: FormBuilder.$options.components,
  store: ["mainExpression", "activeFieldExpression", "tabExpression"],
  props: ["currentField", "isForm"],
  computed: {
    attributesBinding() {
      const { currentField } = this;
      var attr = {};
      if (currentField.id) {
        attr.id = `form-title-${currentField.id}`;
      }
      return attr;
    },
  },
  methods: {
    changeFields(e) {
      if (e.added) {
        e.added.element.id = `${uuidv4()}`;
        this.editElementProperties(e.added.element);
      } else if (e.moved) {
        this.editElementProperties(e.moved.element);
      }
    },
    deleteElement(index, form) {
      if (this.mainExpression != "Edit") return;
      FormBuilder.deleteElement(index, form);
      this.tabExpression = "forms";
    },
    async editElementProperties(field) {
      if (this.mainExpression != "Edit") return;
      vm.$store.isForm = this.isForm;
      if (field.type == "image") {
        vm.$store.activeFieldExpression = {};
        vm.$store.tabExpression = "froms";
      } else {
        vm.$store.tabExpression = "properties";
        vm.$store.activeFieldExpression = field;
      }
    },
  },
};
</script>
<style scoped>
div:empty:before {
  content: attr(data-placeholder);
  color: gray;
}
::v-deep .v-input__slot {
  min-height: 30px !important;
}
h4 {
  user-select: none;
}
</style>
<style lang="scss" scoped>
.form-title {
  min-height: 2rem;
}
.form__actionlist {
  position: absolute;
  visibility: hidden;
  z-index: 3;
  right: -10px;
  bottom: -11px;
  border-radius: 2px;
}

.form__group__element {
  //   margin-bottom: 1rem;
  // margin: 0 15px 0 0;
  border: 1px solid transparent;
  position: relative;
  height: fit-content;
  z-index: 10;
  &.form__group__element--hover {
    &:hover {
      border: 1px solid #409eff !important;
      .form__actionitem--move {
        visibility: visible;
      }
      .form__actionlist {
        visibility: visible;
      }
    }
  }
  &.is--active {
    border-color: #409eff;
    background: #ecf5ff;
    // padding: 0 8px !important;

    .form__actionlist {
      visibility: visible;
    }
    .form__selectedlabel {
      display: inline-block;
    }
  }
}

.preview {
  border: 1px solid #cccccc;
  height: 28.5rem;
}

.upload-file {
  text-align: center;
  height: 130px;
  border: 2px dashed #20a8d8;
  display: flex;
  justify-content: center;
}
.sortable__ghost {
  opacity: 0.5;
}
</style>